import * as React from "react";
import { cn } from "@/lib/utils";

// The design's small uppercase label (11px, 0.18em tracking), used above sections,
// as table headers and as card footers.
export function SectionLabel({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("text-[11px] font-bold uppercase leading-none tracking-label text-waves-muted", className)}
      {...props}
    />
  );
}
